import { FilterFn } from "@tanstack/react-table";

/**
 * Global filter function that searches across all row data.
 * Case-insensitive search across string, number, and boolean values.
 */
 
export const globalFilterFn: FilterFn<any> = (row, _columnId, filterValue) => {
  const search = filterValue.toLowerCase();

  // Get all values from the row
  const rowValues = Object.values(row.original).filter(
    (value) => value !== null && value !== undefined
  );

  // Search in all string values
  return rowValues.some((value) => {
    if (typeof value === "string") {
      return value.toLowerCase().includes(search);
    }
    if (typeof value === "number") {
      return value.toString().includes(search);
    }
    if (typeof value === "boolean") {
      return value.toString().includes(search);
    }
    return false;
  });
};
